import { OnInit, Directive, OnDestroy, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PageModel, PageSort } from './models/page.model';
import { PageableModel } from './models/pageable.model';
import { AuthService } from 'src/app/core/auth/service/auth.service';

@Directive()
export abstract class PageResourceListComponent<T> implements OnInit, OnDestroy {
  public page: PageModel<T> = new PageModel();
  public pageable: PageableModel = new PageableModel();
  public pageSizeOptions: number[] = [5, 10, 25, 30, 50, 100];
  public dataSource!: MatTableDataSource<T>;
  public displayedColumns: string[];

  protected activeRoute: ActivatedRoute;
  protected _authService: AuthService;

  private subscriptionResolveData!: Subscription;

  protected filter?: any;

  constructor(protected injector: Injector, protected mapToRowsCallback?: (content: T[]) => any[]) {
    this.activeRoute = injector.get(ActivatedRoute);
    this._authService = injector.get(AuthService);
    this.dataSource = new MatTableDataSource();
    this.displayedColumns = this.loadDisplayedColumns();
  }

  ngOnInit(): void {
    if (this.activeRoute.snapshot.data.resolveData) {
      this.setResult(this.activeRoute.snapshot.data.resolveData);
    } else {
      this.loadData(this.pageable);
    }
  }

  pageEvent(pageEvent: PageEvent): void {
    this.pageable.page = pageEvent.pageIndex;
    this.pageable.size = pageEvent.pageSize;
    this.loadData(this.filter);
  }

  sortEvent(sortEvent: any): void {
    this.pageable.sort = new PageSort(sortEvent.active, sortEvent.direction);
    this.loadData(this.filter);
  }

  protected setResult(page: PageModel<T>): void {
    if (this.mapToRowsCallback) {
      this.dataSource.data = this.mapToRowsCallback(page.content);
    } else {
      this.dataSource.data = page.content;
    }
    this.page = page;
  }

  public loadData(filter?: any) {
    this.filter = filter;
    this.loadDataHandler(this.pageable, this.filter).subscribe(result => {
      this.setResult(result);
    });
  }

  protected abstract loadDataHandler(pageable: PageableModel, filter?: any): Observable<PageModel<T>>;

  protected abstract loadDisplayedColumns(): string[];

  ngOnDestroy(): void {
    if (this.subscriptionResolveData) {
      this.subscriptionResolveData.unsubscribe();
    }
  }
}
